import { getPlatform } from "@tencent/h5-env-enhance";
import { BeaconUtil } from "@tencent/pitu-data-report";
import { getQueryParam } from "./url";
import { isPrdEnv } from "./env";
import { currentTraceId } from "./uuid";
export const ParamsMapping = {
    /** H5打开来源 */
    SOURCE: 'source',
    /** 分享层级 */
    LEVEL: 'level',
    /** 活动id */
    ACTIVITY_ID: 'activity_id',
    /**天机阁 traceId */
    TPS_ID: 'tps_id',
    /** QQ号(仅在qq内有cookie情况下上报) */
    QQ: 'qq',
    PAGE_ID: 'page_id',
    BTN_ID: 'btn_id',
    PLATFORM: 'platform_name',
    EXPERIMENT_ID: 'experiment_id',
    ERR_CODE: 'err_code',
    ERR_MSG: 'err_msg',
    USER_AGENT: 'user_agent',
    TRACE_ID: 'trace_id',
    PARENT_TRACE_ID: 'parent_trace_id',
    CURRENT_CHANNEL: 'current_channel',
    ROOT_CHANNEL: 'root_channel',
    VIDEO_URL: 'video_url',
    FACE_NUM: 'face_num',
    MATERIAL_ID: 'material_id',
    SUB_MATERIAL_ID: 'sub_material_id',
};
let beacon;
/**
 * 使用demo:
 *
 * 1.  页面pv上报
 * beacon.reportPV();
 *
 * 2. 页面事件上报，第二个参数可以传入事件上报需要的参数数组，不传则上报所有字段
 * beacon.reportEvent('user#custom#event');
 */
export function getBeacon() {
    if (!beacon) {
        beacon = new BeaconUtil({
            static: {},
            dataFiled: ParamsMapping,
            appKey: '0WEB02VMLD4EVVMN',
            versionCode: '0.0.1',
            debug: !isPrdEnv(),
        });
        // 防止重复set
        const reportId = document.querySelector('meta[name="reportId"]').getAttribute('content');
        beacon.setValue({
            SOURCE: getQueryParam('source', 'link'),
            LEVEL: getQueryParam('level', '0'),
            ACTIVITY_ID: reportId || 'vision_debug',
            PLATFORM: getPlatform(),
            USER_AGENT: navigator.userAgent,
            TRACE_ID: currentTraceId,
            PARENT_TRACE_ID: getQueryParam('parent_trace_id', currentTraceId),
            CURRENT_CHANNEL: getQueryParam('current_channel', ''),
            ROOT_CHANNEL: getQueryParam('root_channel', ''),
            EXPERIMENT_ID: Math.random() < 0.5 ? 'index_gif,jump_qq' : 'index_gif,jump_pitu',
        });
    }
    return beacon;
}
export function reportPV(pageId) {
    getBeacon().setValue({ PAGE_ID: pageId });
    getBeacon().reportEvent('pv');
}
export function reportBtnClick(btnId) {
    getBeacon().setValue({ BTN_ID: btnId });
    getBeacon().reportEvent('btn_click');
}
export function reportError({ errCode, errMsg }) {
    getBeacon().setValue({
        ERR_CODE: errCode,
        ERR_MSG: errMsg
    });
    getBeacon().reportEvent('err');
}
export function getValue(key) {
    return getBeacon().getGlobalParams(key);
}
export function setValue(key, value) {
    getBeacon().setValue({
        [key]: value
    });
}
export const shareTraceAndChannelLink = (currentChannel = '') => `parent_trace_id=${currentTraceId}&current_channel=${currentChannel || getQueryParam('current_channel', '')}&root_channel=${getQueryParam('root_channel', '')}&level=${parseInt(getQueryParam('level', '0'), 10) + 1}`;
